Controller = App.loadClass 'core::Angular/Controller'

class exports.SidebarController extends Controller
    constructor: (@scope, @transitions, @service, @deleteService, @state, @q, @http, @timeout, @modal, @ngModal, @stateParams) ->
        super
        @scope.show_fullpage = false
        @scope.show_fullpage_fn = @showFullpage
        @scope.selectedClass = 'success'
        @scope.unselectedClass = ''

        @scope.selected_options = {
            year: null,
            crop: null,
            field: null,
        }

        @scope.deleteService = @deleteService
        @scope.service = @service
        @scope.years = []
        @scope.crops = []
        @scope.fields = []
        @scope.filteredFields = []

        @scope.loading = false
        @scope.fpcResults = []
        @scope.createError = null
        @scope.fieldName = @fieldName
        @scope.isPBIConnected = false
        @scope.isUploadedPBIConnected = false

        @scope.pbiLauncherOptions = {
            resolve: {
                mode: 'edit'
                field: {}
                year: null
                hideFieldName: true
            },
        }

        @scope.uploadedPbiLauncherOptions = {
            mode: 'edit'
            field: {}
            year: null
            hideFieldName: true
        }

        @scope.companyName = null

        @scope.startFieldprint = @startFieldprint
        @scope.editFieldprint = @editFieldprint
        @scope.editFieldprintClick = @editFieldprintClick
        @scope.inFieldprintProcess = @inFieldprintProcess
        @scope.inFieldprintScores = @inFieldprintScores
        @scope.inFieldprintScore = @inFieldprintScore
        @scope.gotoStep = @gotoStep
        @scope.rowClick = @rowClick
        @scope.bulkDelete = @bulkDelete
        @scope.openOtherPractices = @openOtherPractices
        @scope.editIrrigationMap = @editIrrigationMap
        @scope.resizeTable = 0

        @scope.showCargillMessage = @showCargillMessage

        @scope.currentStepIs = @currentStepIs
        @scope.stepVisited = @stepVisited
        @scope.stepSaved = @stepSaved
        @scope.getClass = @getClass

        @scope.copyFieldprint = @copyFieldprint
        @scope.loadFpcResults = @loadFpcResults

        @scope.calculatorSucceeded = @calculatorSucceeded
        @scope.calculatorErrored = @calculatorErrored
        @scope.openUploadedPBIConnections = @openUploadedPBIConnections

        @scope.numSteps = () =>
            return Object.keys(@service.config[@service.crop].steps.value).length

        # @scope.loaded = (fpcResult) ->
        #     ifHasDryland = fpcResult.dryland_scores and (fpcResult.irrigated_scores or not fpcResult.data.irrigated)
        #     ifDoesntHasDryland = fpcResult.irrigated_scores and fpcResult.data.irrigated and not fpcResult.dryland_request
        #     return ifHasDryland or ifDoesntHasDryland

        hasMessage = (message, fpcResult) ->
            return typeof(fpcResult.dryland_response) is 'string' and fpcResult.dryland_response?.indexOf(message) >= 0 or typeof(fpcResult.irrigated_response) is 'string' and fpcResult.irrigated_response?.indexOf(message) >= 0

        # @scope.badSoils = (fpcResult) ->
        #     return hasMessage 'Missing param: slope', fpcResult

        # @scope.badZone = (fpcResult) ->
        #     return hasMessage 'Missing param: cmz_id', fpcResult

        # @scope.badData = (fpcResult) ->
        #     return hasMessage 'Request failed with code 400', fpcResult


        @scope.selected_options.field = null

        @loadScopeData @service.getYears(), 'years'
        @loadScopeData @service.getCrops(), 'crops'
        @service.brandNew = false

        # Resetting the service does not clear the year, crop, or field
        @service.reset()
        @scope.selected_options.year = @service.year
        @service.getCrops().then (crops) =>
            @scope.selected_options.crop = @service.crop if crops.data.data.includes @service.crop
        # @scope.selected_options.field = @service.field

        if @stateParams.year or @stateParams.crop
            # if we navigated here from a declaration survey (currently just ussap), set the year and crop
            @scope.selected_options.year = @stateParams.year
            @scope.selected_options.crop = @stateParams.crop

        @http.post('backend/grower/fieldprint/fields')
        .then (response) =>
            @scope.fields = response.data

            @loadFpcResults()
            @loadUploadedPBIConnection()
            @loadPBIConnection(@scope.selected_options.year)

        @http.get('backend/user-info/company').then (response) =>
            @scope.companyName = response.data.internal_name

        @service.onDataLoaded @scope, () =>
            # If we navigated directly to a fieldprint, set the field in the dropdown
            @scope.selected_options.year = @service.year
            @scope.selected_options.crop = @service.crop if @service.crops and @service.crops.includes @service.crop
            @scope.selected_options.field = @service.field if @service.crops and @service.crops.includes @service.crop

        @scope.$watch 'selected_options.year', (year, old) =>
            if parseInt(year) is parseInt(old)
                return

            @scope.fpcResults = []
            @loadFpcResults()

            # reload PBI data since some of it (cottonhost) depends on year
            @loadPBIConnection(year)

            @scope.selected_options.field = null
            @scope.resizeTable += 1

        @scope.$watch 'selected_options.crop', () =>
            @scope.resizeTable += 1

        @scope.$watchCollection 'fpcResults', (results) =>
            @scope.resizeTable += 1

        # This integrates SAFElink functionality
        @scope.$on 'app:safelinked', () =>
            # Reset everything if safelinked to a new person
            @state.go 'grower.fieldprint', {}, reload: 'grower.fieldprint'

        @scope.$on 'fieldprintChanged', (event, newFpcResult) =>
            # navigation assistant needs to update its fieldprint data
            @ngModal.refreshNavigationAssistantStep('add_fieldprint_analyses')
            if not newFpcResult or parseInt(newFpcResult.year) isnt @scope.selected_options.year
                return

            _.remove @scope.fpcResults, (fpcResult) =>
                fpcResult.id is newFpcResult.id

            @scope.fpcResults.push newFpcResult

            @filterFieldsInDropdown()

    checkOtherPractices: (year) =>
        filtered = @scope.fpcResults.filter (result) =>
            return result.year is parseInt(year)

        @scope.hasOtherPractices = filtered.length > 0

    filterFieldsInDropdown: () =>
        @scope.filteredFields = @scope.fields.filter (field) =>
            for fpcResult in @scope.fpcResults
                if fpcResult.fields_id is field.field_id
                    return false
            return true

    showCargillMessage: () =>
        if @scope.companyName is 'Cargill' and not @inFieldprintProcess() and ((@scope.selected_options.field and @scope.selected_options.year and @scope.selected_options.crop) or @scope.fpcResults.length > 0)
            return true
        return false

    # Accepts either integer id or field object, because ui-select is stupid and sets either to $select.selected
    fieldName: (field) =>
        if typeof(field) isnt 'object'
            field = _.find @scope.fields, { field_id: field }

        "#{field?.farm_name} - #{field?.field_name}"

    startFieldprint: () =>
        @service.reset()
        @service.createFieldprint(
            @scope.selected_options.year
            @scope.selected_options.crop
            @scope.selected_options.field
        ).then (response) =>
            @scope.createError = null
            @service.brandNew = true
            @scope.fpcResults.push response.data
            @service.gotoStep 0, response.data.id, false
        .catch (error) =>
            if error.status is 422
                if error.data.year.unique
                    @scope.createDuplicateError = true
                else
                    @scope.createError = JSON.parse(error.data)

                @timeout () =>
                    @scope.createError = null
                    @scope.createDuplicateError = null
                , 5000

    getBoundaryImage: () =>
        return @http.post 'backend/grower/fieldprint/boundary-image', { fpcResultId: @fpcResult.id }

    # Using just editFieldprint() would work, but this keeps the wrong message from displaying on the Scores page.
    editFieldprintClick: (id) =>
        if @state.includes('grower.fieldprint.score')
            @state.go 'grower.fieldprint'
            .then () => @editFieldprint(id)
        else
            @editFieldprint(id)

    editFieldprint: (id) =>
        @service.reset()
        @service.brandNew = false
        @service.loadFieldprint id
        .then () =>
            @scope.selected_options.year = @service.year
            # If the user clicks a fieldprint for another company with a crop that the curent company doesn't have
            # we don't want to select the unavailable crop in the sidebar
            if @service.crops and @service.crops.includes @service.crop
                @scope.selected_options.crop = @service.crop
                @scope.selected_options.field = @service.field
                @service.goToFirstIncompleteStep(id)


    gotoStep: (stepName) =>
        @service.gotoStep @service.findStepIndexByName(stepName), @service.fpcResult.id, true, true

    getClass: (row) =>
        return row.class

    bulkDelete: () =>
        if @state.includes('grower.fieldprint.score')
            # reload the state
            @state.go 'grower.fieldprint'

        @deleteService.toggle(@scope.fpcResults)

    rowClick: (fpcResult, event) =>
        return unless event.target.nodeName is 'TD' or event.target.nodeName is 'DIV'

        if @deleteService.active
            # handle bulk delete highlighting
            @deleteService.selectRow(fpcResult, @scope.fpcResults)
        else
            # enter or exit score state (to view fpc results)
            @viewFieldprintScore(fpcResult, event)

    viewFieldprintScore: (fpcResult, event) =>
        if @state.includes('grower.fieldprint.score') and @state.params.id is fpcResult.id
            @state.go 'grower.fieldprint'
        else
            # This liiiiiittle hack here prevents us from having to do an expensive HTTP call when loading the scores page. We already have the information so use it!
            @service.fpcResult = fpcResult
            @service.year = fpcResult.year
            @service.crop = fpcResult.ftm_crop.name
            @service.field = fpcResult.fields_id
            @scope.pbiLauncherOptions.resolve.field.id = fpcResult.fields_id
            @scope.pbiLauncherOptions.resolve.field.name = fpcResult.field.name
            @scope.pbiLauncherOptions.resolve.year = fpcResult.year
            @scope.uploadedPbiLauncherOptions.field = fpcResult.field
            @scope.uploadedPbiLauncherOptions.year = fpcResult.year

            @state.go 'grower.fieldprint.score', { id: fpcResult.id }

    showFullpage: () =>
        @inFieldprintProcess() or @inFieldprintScores()

    inFieldprintProcess: () =>
        @state.includes 'grower.fieldprint.step'

    inFieldprintScores: () =>
        @state.includes 'grower.fieldprint.score'

    inFieldprintScore: (id) =>
        @inFieldprintScores() and @state.params.id is id

    currentStepIs: (stepName) =>
        stepName is @service.currentStepName

    stepVisited: (stepName) =>
        @service.visitedSteps.indexOf(stepName) isnt -1

    stepSaved: (stepName) =>
        @service.savedSteps.indexOf(stepName) isnt -1

    copyFieldprint: () =>
        @modal.open
            windowClass: 'modal-width'
            controller: 'Fieldprint.Controllers.CopyFieldprintController'
            templateUrl: 'backend/grower/fieldprint/copy-fieldprint-dialog'
            scope: @scope.$new()
            resolve:
                fpcResultId: () => @state.params.id
                year: () => @scope.selected_options.year
                fpcResults: () =>
                    @http.get 'backend/grower/fieldprint/fpc-results/all'
                    .then (response) -> response.data
                fields: () => @scope.fields
        .result.then @loadFpcResults

    loadFpcResults: () =>
        # navigation assistant needs to update its fieldprint data
        @ngModal.refreshNavigationAssistantStep('add_fieldprint_analyses')

        @scope.loading = true
        year = if @scope.selected_options.year? then @scope.selected_options.year else moment().format 'YYYY'
        @http.get("backend/grower/fieldprint/fpc-results?year=#{year}&hide=events,irrigation_map")
        .then (response) =>
            @scope.loading = false
            @scope.fpcResults = response.data
            @checkOtherPractices year
            @filterFieldsInDropdown()

    loadPBIConnection: (year) =>
        @http.get('backend/grower/pbi/has-connection', { params: { year } })
        .then (response) =>
            @scope.isPBIConnected = response.data.has_connection

    loadUploadedPBIConnection: () =>
        @service.hasPBIUploadedConnection(@service.year).then (response) =>
            @scope.isUploadedPBIConnected = response.data

    openOtherPractices: () =>
        @http.post 'backend/grower/other-practices/load',
            year: @scope.selected_options.year
            crop: @scope.selected_options.crop
        .then (response) =>
            @modal.open
                windowClass: 'medlarge_dialog'
                controller: 'Fieldprint.Controllers.OtherPracticesController'
                templateUrl: 'backend/grower/fieldprint/other-practices-dialog'
                scope: @scope.$new()
                resolve:
                    selections: () => {
                        year: @scope.selected_options.year
                        crop: @scope.selected_options.crop
                    }
                    survey: () => response.data

    editIrrigationMap: () =>
        @service.save @service.fpcResult.id
        .then () =>
            @state.go "grower.fieldprint-edit-zone",
                request: JSON.stringify({
                    year: @service.year
                    field_id: @service.field
                    crop: @service.crop
                    layer_id: @service.fpcResult.irrigation_map.id
                    layers_title: @service.fpcResult.irrigation_map.name
                    redirectId: @state.params.id
                    redirectState: 'fieldprint'
                    step: @state.params.step
                })

    # Opens the uploaded pbi connections dialog
    openUploadedPBIConnections: () =>
        @ngModal.openUploadedPBIConnectionsDialog('edit', @scope.uploadedPbiLauncherOptions.year, @scope.uploadedPbiLauncherOptions.field, true)
        .modalRef.result.catch _.noop

